import { ModernSelect, SelectOption } from "@components/Select";
import { Box, SelectChangeEvent, Skeleton } from "@mui/material";
import { useClients } from "@services/api";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface ClientSelectorProps {
  selectedClient: string;
  setSelectedClient: (clientId: string) => void;
}

const ClientSelector = ({
  selectedClient,
  setSelectedClient
}: ClientSelectorProps) => {
  const { t } = useTranslation();

  const { data: clients, isFetching: isLoading } = useClients();

  const onClientSelectChange = (event: SelectChangeEvent<string>) => {
    const clientId = event.target.value;
    setSelectedClient(clientId.toString());
  };

  const clientsOptions = useMemo(() => {
    return (clients || [])
      .sort((a, b) =>
        dayjs(b.created_at, "yyyy-MM-dd").diff(
          dayjs(a.created_at, "yyyy-MM-dd")
        )
      )
      .reduce((acc, client) => {
        acc.push({
          value: client.id,
          label: client.label || client.name
        });
        return acc;
      }, [] as SelectOption[]);
  }, [clients]);

  return (
    <Box className="flex justify-center w-full">
      {isLoading ? (
        <Skeleton variant="rectangular" width="100%" height={40} />
      ) : (
        <ModernSelect
          options={clientsOptions}
          value={selectedClient}
          onChange={onClientSelectChange}
          valueKey="id"
          labelKey="name"
          label={`${t("clientExternalEffects.selectClient")} *`}
          showIndicatorDot={true}
          colorTheme="light"
          id="mmm-model-currency-helper"
          disabled={isLoading}
        />
      )}
    </Box>
  );
};

export default ClientSelector;
